import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * Input Component - INFLUENCITY-TIER
 * 
 * All colors route through granullo.tokens.css
 */

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full px-3 py-1 text-base md:text-sm",
        "rounded-[var(--g-input-radius)]",
        "border border-[var(--g-input-border)]",
        "bg-[var(--g-input-bg)]",
        "text-[var(--g-input-text)]",
        "shadow-[var(--g-shadow-low)]",
        "transition-all duration-[var(--g-dur-1)] ease-[var(--g-ease-out)]",
        // File input
        "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-[var(--g-text)]",
        // Placeholder
        "placeholder:text-[var(--g-input-placeholder)]",
        // Focus
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--g-focus-ring)] focus-visible:border-[var(--g-input-border-focus)]",
        // Disabled
        "disabled:cursor-not-allowed disabled:bg-[var(--g-btn-disabled-bg)] disabled:text-[var(--g-btn-disabled-text)]",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
